import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15679407"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-items-start tw-p-[20px] tw-h-[130px] tw-justify-between tw-self-stretch tw-bg-[#ffffff] container" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-justify-between tw-h-full" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-medium tw-leading-[130%]" }


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentValueCard',
  props: {
  title: {
    type: String,
    required: false,
    default: "",
  },
  value: {
    type: [Number, String],
    required: false,
    default: 0,
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
      _renderSlot(_ctx.$slots, "value", {}, () => [
        _createElementVNode("div", {
          class: _normalizeClass(["tw-text-[#211F58] tw-font-[Poppins] tw-text-[35px] tw-font-semibold tw-leading-[100%]", __props.customClass])
        }, _toDisplayString(__props.value), 3)
      ])
    ]),
    _renderSlot(_ctx.$slots, "rightContent")
  ]))
}
}

})